import React from "react";
import { Steps } from "antd";
import progressDescription from "./progressDescription";
// import './FormProgress.css';

const { Step } = Steps;

const FormProgress = ({ progress }) => {
  const idx = progress.find(p => p.completed === false);
  return (
    <div className="executor-sidebar-progress">
      <div className="executor-sidebar-progress__title">
        Прогресс заполнения
      </div>
      <div className="executor-sidebar-progress__list">
        <Steps direction="vertical" size="small" current={1}>
          {progress.map((item, index) => {
            return (
              <Step
                key={index}
                title={item.title}
                description={item.completed && progressDescription(item)}
                status={
                  idx && item.name === idx.name
                    ? "process"
                    : item.completed
                    ? "finish"
                    : "wait"
                }
              />
            );
          })}
        </Steps>
      </div>
    </div>
  );
};

export default FormProgress;
